import t from "../../Actions/VirtualTerminalActions/types";

const initialState = {
  config: null,
  products: [],
  tenants: [],
  unitToken: null,
  transactions: [],
  saleResult: null,
  loading: false,
};

// eslint-disable-next-line default-param-last
const VirtualTerminalReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.VTERM_SET_CONFIG: {
      if (!action.payload) {
        return { ...state, config: null, products: [], tenants: [] };
      }
      return {
        ...state,
        config: action.payload.config,
        products: action.payload.products || [],
        tenants: action.payload.tenants || [],
      };
    }
    case t.VTERM_SET_UNIT_TOKEN: {
      return { ...state, unitToken: action.payload };
    }
    case t.VTERM_SET_TRANSACTIONS: {
      return { ...state, transactions: action.payload || [] };
    }
    case t.VTERM_SALE_RESULT: {
      return { ...state, saleResult: action.payload };
    }
    case t.VTERM_CLEAR_SALE_RESULT: {
      return { ...state, saleResult: null };
    }
    case t.VTERM_SET_LOADING: {
      return { ...state, loading: action.payload };
    }
    default:
      return state;
  }
};

export default VirtualTerminalReducer;
